// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Switch, Route } from 'react-router-dom'

// Internal Dependencies:
import createHistoryHashObserver from 'church-theme-library/utilities/createHistoryHashObserver'
import { getUrlParameter, removeURLParameter } from 'church-theme-library/utilities/url'
import PageEvents from './PageEvents'
import Recaptchas from './Recaptchas'
import Locale from './Locale'

// Redux:
import { setOnLineStatus, setConnectionStatus } from 'church-theme-library/redux/actions/site'

class SiteContainer extends React.Component {
	componentDidMount() {
		const { history, dispatch } = this.props
		const historyHashObserver = createHistoryHashObserver( history )

		// Check url:
		const doingLogin = getUrlParameter( 'doing_login' )

		if ( doingLogin ) {
			removeURLParameter( 'doing_login' )
		}

		// General update:
		this.update()

		// Connection speed:
		this.nativeConnection = !! window.navigator.connection

		if ( this.nativeConnection ) {
			this.updateConnectionStatus()

			navigator.connection.addEventListener( 'onchange', this.updateConnectionStatus )
		}

		this.updateOnLineStatus()
		window.addEventListener( 'online', this.updateOnLineStatus )
		window.addEventListener( 'offline', this.updateOnLineStatus )
	}

	componentDidUpdate() {
		this.update()
	}

	componentWillUnmount() {
		// Connection speed:
		if ( this.nativeConnection ) {
			navigator.connection.removeEventListener( 'onchange', this.updateConnectionStatus )
		}

		window.removeEventListener( 'online', this.updateOnLineStatus )
		window.removeEventListener( 'offline', this.updateOnLineStatus )
	}

	update = () => {
		// Page data used by DK Editor:
		const { dkePageData } = this.props
		const dkePageDataJson = JSON.stringify( dkePageData )

		document.body.setAttribute( 'data-dke-page-data', dkePageDataJson )
	}

	updateConnectionStatus = () => {
		if ( ! navigator.onLine ) {
			return
		}

		const { dispatch } = this.props

		dispatch( setConnectionStatus( {
			effectiveType: navigator.connection.effectiveType,
			downlink: navigator.connection.downlink,
			rtt: navigator.connection.rtt
		} ) )
	}

	updateOnLineStatus = () => {
		const { dispatch } = this.props

		dispatch( setOnLineStatus( navigator.onLine ) )
	}

	render() {
		const { locales } = this.props

		// Pass through each locale slug.
		// Eg: example.com/es, example.com/fr.
		const localesRoutes = locales.length > 1 ? locales.map( e => {
			return <Route path={ '/' + e.slug + '/' } component={ Locale } key={ e.slug } />
		} ) : null

		return (
			<div>
				<PageEvents />
				<Recaptchas match={ this.props.match } />

				<Switch>
					{ localesRoutes }

					<Route path="/" component={ Locale } />
				</Switch>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		dkePageData: state.page.dkePageData,
		locales: state.site.locales
	}
}

export default connect( mapStateToProps )( SiteContainer )
